import { render, staticRenderFns } from "./m-tabs.vue?vue&type=template&id=3fb09c2b&scoped=true&"
import script from "./m-tabs.vue?vue&type=script&lang=ts&"
export * from "./m-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./m-tabs.vue?vue&type=style&index=0&id=3fb09c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb09c2b",
  null
  
)

export default component.exports